/**
 * Utils
 * @module Utils
 */
var dummyVideoTrack = null;
var dummyTrackInterval = null;
var canvas = null;
// It is used at the begining of connection, if video track is not yet available.
// Without that video player on remote peer may not start playing audio/video content
export function getDummyVideoTrack() {
    if (!dummyVideoTrack) {
        canvas = document.createElement("canvas");
        // Workaround for FF only: https://bugzilla.mozilla.org/show_bug.cgi?id=1572422
        // canvas.getContext needs to be called before captureStream to avoid
        // NS_ERROR_NOT_INITIALIZED being thrown.
        canvas.getContext('2d');
        var stream = canvas.captureStream();
        dummyVideoTrack = Object.assign(stream.getVideoTracks()[0], { enabled: false });
    }
    var width = 320, height = 180;
    var ctx = canvas.getContext('2d');
    dummyTrackInterval = setInterval(function () {
        ctx.fillRect(0, 0, width, height);
    }, 1000);
    return dummyVideoTrack;
}
export function stopDummyVideoTrack() {
    if (dummyTrackInterval) {
        clearInterval(dummyTrackInterval);
        dummyTrackInterval = null;
        return true;
    }
    return false;
}



//////////////////
// WEBPACK FOOTER
// ./src/utils.ts
// module id = 132
// module chunks = 1